<template>
  <div class="rightcontent">
    <div class="midContent">
      <div class="content">
        <div ref="webgl" id="webglPano">
          <div
            v-if="point.show"
            class="points active"
            :style="'left:'+point.x+'px;top:'+point.y+'px'"
            @mousedown="movePoint($event)"
          >
            <img :src="'imgs/points/'+point.url+'.png'" style="width:100%" />
          </div>
        </div>
      </div>
      <BottomBar :nowPanoItemIndex="nowPanoActiveIndex" :resInfos="infos" :resData="resData" :nowFloor="nowFloor"></BottomBar>
    </div>
    <div class="PageLayout_sidebar_1JSEld"><div class="FillBlock-hzrSuI zVQab"><div style="position: relative; overflow: hidden; width: 100%; height: 100%;"><div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; overflow: scroll; margin-right: -17px; margin-bottom: -17px;"><div style="padding: 20px 15px;"><div class="block-horizontal-layout block-justify-between block-align-center" style="margin-bottom: 10px;"><div class="block-horizontal-layout block-align-center">背景音乐<a href="" target="_blank" rel="noopener noreferrer"><img class="HelpIcon_root_WFV-sl" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAA81BMVEUAAACzs7Orq6urq6urq6urq6uqqqqqqqqrq6uqqqqurq6qqqqqqqqsrKyqqqqrq6utra2srKysrKyurq6qqqosLCympqZra2ucnJxDQ0N+fn5lZWWhoaF/f39xcXGSkpI0NDRvb2+kpKSZmZmlpaWdnZ2bm5s4ODhGRkaoqKinp6dAQEA5OTlPT0+Dg4N0dHSKioo6OjpFRUU1NTV3d3eTk5OBgYFnZ2cxMTGJiYmWlpaLi4tYWFgyMjJISEgtLS0zMzOEhIR5eXk/Pz9ERERMTExdXV2UlJRNTU1ubm49PT2YmJh4eHienp5RUVFZWVlOTk58rGCDAAAAFHRSTlMACrxto/4GivjhFsQ/WR77HyUrJiy7ftYAAAGQSURBVHhenZTlbuRAEAZtL1M2zlablyEIh8zM8P5Pc9nb0XTGuZOlq9+lac3X4Ln4YX8w6Ie+90/2asEQAIZBbe+vyn69gUKjvn9DabbaAMvxJM8n4yVAu9V0nW4PKOJUDGlcAL3udeegA9F8JorM5hF0DtTpdmB9JCWO1tCxbzV7MD2UG5xNodc0UgvWxkkvvifj1FpraJm/t4lMrZ/HANEzWzGivUuiDvOdc7oCgMVtMcyh/ifnBoX51yXcenfnKdyzfyxobLOvQSw7EhZX+t0VUzFIDLUrKYDUSBGPt+59FlZKIfA8f8hSDA94KCKPTngiliVD3xtBJobnL16KvHoNb1TKIPT6MBFF4hUcv1VpAn1vALko7wE+iJLDoCzF8PGTlKRyuc9ga2m5EDL3pZkjjSE0EVi+fP1mBY1AwyyjYWpbymhbbIMt50nyQ8RtsI6KIYFExB0VHTqVNuIOnY6vltv8csa3YhEOdREqVqpiOU/c5axec/dgZNuDkenBqDw9/3HEFH+0PYcj3xV+A578V+4+4HKVAAAAAElFTkSuQmCC" alt="" style="margin-left: 10px;"></a></div>
    <a @click='chooseAudio' class="pano-button pano-button-sm pano-button-primary">选择音频</a></div><div style="margin-bottom: 20px;">
      <div>
      <div class="ContentBox_box_18qEQ3" style="height: 50px; padding: 0px 10px;">
        <div v-if='musicUpload==false'>请使用MP3格式</div>
        <div style="position:relative;width:100%" v-if='musicUpload'>
          <img style='position:absolute;left:0px' @click="playOrPause('music')" :src="musicIconSrc" class="AudioPlayer__Img-ebAYfU gCOZys">
          <audio ref="music" :src="musicSrc"></audio> 
          <div style="line-height: 17px;margin-left:45px;text-align:left"><div class="AudioPlayer__Name-lmjRpA hyFrqY">{{musicTtile}}</div><a class="TextLink-krgCEr NbaJv" @click='deleteMusic'>删除</a></div>
        </div> 
        </div>
        <!-- <div style="margin-top: 20px;">
          <div class="AudioPlayer__Row-kgvCjN fCtgHg" style="margin-bottom: 10px;">
            <span>音量</span>
            <span>100%</span>
            </div>
          <div class="rc-slider">
          <div class="rc-slider-rail" style="background-color: rgb(43, 43, 43); border: 1px solid rgb(67, 67, 67); border-radius: 0px;"></div>
          <div class="rc-slider-track" style="background-color: rgb(65, 121, 249); border: 1px solid rgb(67, 67, 67); border-radius: 0px; left: 0%; width: 100%;"></div>
          <div class="rc-slider-step"></div>
          <div tabindex="0" class="rc-slider-handle" role="slider" aria-valuemin="0" aria-valuemax="1" aria-valuenow="1" aria-disabled="false" style="border: 1px solid rgb(255, 255, 255); background-color: rgb(223, 223, 223); left: 100%;"></div>
          <div class="rc-slider-mark"></div></div>
        </div> -->
        <div class="AudioPlayer__Row-kgvCjN fCtgHg" style="margin-top: 20px;">
          <div>默认开启<span class="AudioPlayer__Tip-bZFAFW jDvrWE">(进入场景自动播放)</span></div>
          <div class="Checkbox_container_jYKPxJ">
            <div @click='changeAuto' :class="{'Checkbox_checkbox_2hIu2H':true, 'Checkbox_checked_3yFHX3':isauto}" style="width: 14px; height: 14px;">
              <span class="SVGInline"><svg class="SVGInline-svg" fill="#fff" style="width: 10px;height: 10px;" width="8" height="7" viewBox="0 0 8 7" xmlns="http://www.w3.org/2000/svg"><path d="M7.146 0l-4.36 4.39L.81 2.412 0 3.371l2.757 2.756L8 .854z" fill-rule="evenodd"></path></svg></span></div></div>
        </div>
        <div class="AudioPlayer__Row-kgvCjN fCtgHg" style="margin-top: 20px;">
          <div>循环播放<span class="AudioPlayer__Tip-bZFAFW jDvrWE">(不勾选则只播放1次)</span></div>
          <div class="Checkbox_container_jYKPxJ">
            <div @click='changeLoop' :class="{'Checkbox_checkbox_2hIu2H':true, 'Checkbox_checked_3yFHX3':isloop}" style="width: 14px; height: 14px;">
              <span data-v-19760c0a="" class="SVGInline"><svg data-v-19760c0a="" fill="#fff" width="8" height="7" viewBox="0 0 8 7" xmlns="http://www.w3.org/2000/svg" class="SVGInline-svg" style="width: 10px; height: 10px;"><path data-v-19760c0a="" d="M7.146 0l-4.36 4.39L.81 2.412 0 3.371l2.757 2.756L8 .854z" fill-rule="evenodd"></path></svg></span>
              </div></div>
          </div>
        </div></div><div style="margin-bottom: 10px;"><div class="ApplyTo_root_EGt0qa">应用到：<a class="pano-button pano-button-xs pano-button-outline ApplyTo_btn_1viHCu" @click="selectScene()">选择场景</a></div></div></div><div style="width: 100%; height: 2px; border-top: 1px solid rgb(0, 0, 0); border-bottom: 1px solid rgb(75, 75, 75);"></div><div style="padding: 20px 15px;"><div class="block-horizontal-layout block-justify-between block-align-center" style="margin-bottom: 10px;"><div class="block-horizontal-layout block-align-center">语音讲解<a href="" target="_blank" rel="noopener noreferrer"><img class="HelpIcon_root_WFV-sl" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAA81BMVEUAAACzs7Orq6urq6urq6urq6uqqqqqqqqrq6uqqqqurq6qqqqqqqqsrKyqqqqrq6utra2srKysrKyurq6qqqosLCympqZra2ucnJxDQ0N+fn5lZWWhoaF/f39xcXGSkpI0NDRvb2+kpKSZmZmlpaWdnZ2bm5s4ODhGRkaoqKinp6dAQEA5OTlPT0+Dg4N0dHSKioo6OjpFRUU1NTV3d3eTk5OBgYFnZ2cxMTGJiYmWlpaLi4tYWFgyMjJISEgtLS0zMzOEhIR5eXk/Pz9ERERMTExdXV2UlJRNTU1ubm49PT2YmJh4eHienp5RUVFZWVlOTk58rGCDAAAAFHRSTlMACrxto/4GivjhFsQ/WR77HyUrJiy7ftYAAAGQSURBVHhenZTlbuRAEAZtL1M2zlablyEIh8zM8P5Pc9nb0XTGuZOlq9+lac3X4Ln4YX8w6Ie+90/2asEQAIZBbe+vyn69gUKjvn9DabbaAMvxJM8n4yVAu9V0nW4PKOJUDGlcAL3udeegA9F8JorM5hF0DtTpdmB9JCWO1tCxbzV7MD2UG5xNodc0UgvWxkkvvifj1FpraJm/t4lMrZ/HANEzWzGivUuiDvOdc7oCgMVtMcyh/ifnBoX51yXcenfnKdyzfyxobLOvQSw7EhZX+t0VUzFIDLUrKYDUSBGPt+59FlZKIfA8f8hSDA94KCKPTngiliVD3xtBJobnL16KvHoNb1TKIPT6MBFF4hUcv1VpAn1vALko7wE+iJLDoCzF8PGTlKRyuc9ga2m5EDL3pZkjjSE0EVi+fP1mBY1AwyyjYWpbymhbbIMt50nyQ8RtsI6KIYFExB0VHTqVNuIOnY6vltv8csa3YhEOdREqVqpiOU/c5axec/dgZNuDkenBqDw9/3HEFH+0PYcj3xV+A578V+4+4HKVAAAAAElFTkSuQmCC" alt="" style="margin-left: 10px;"></a></div>
        <a @click='chooseAudio1' class="pano-button pano-button-sm pano-button-primary">选择音频</a></div><div style="margin-bottom: 20px;"><div><div class="ContentBox_box_18qEQ3" style="height: 50px; padding: 0px 10px;">
          <div v-if='audioUpload==false'>请使用MP3格式</div>
          <div style="position:relative;width:100%" v-if='audioUpload'>
          <img style='position:absolute;left:0px' @click="playOrPause('audio')" :src="audioIconSrc" class="AudioPlayer__Img-ebAYfU gCOZys">
          <audio ref="audio" :src="audioSrc"></audio> 
          <div style="line-height: 17px;margin-left:45px;text-align:left"><div class="AudioPlayer__Name-lmjRpA hyFrqY">{{audioTtile}}</div><a class="TextLink-krgCEr NbaJv" @click='deleteAudio'>删除</a></div>
        </div>  
          </div></div></div><div style="margin-bottom: 10px;">
            <div class="ApplyTo_root_EGt0qa">应用到：<a class="pano-button pano-button-xs pano-button-outline ApplyTo_btn_1viHCu" @click='selectScene1'>选择场景</a></div></div></div></div><div style="position: absolute; height: 6px; right: 2px; bottom: 2px; left: 2px; border-radius: 3px;"><div style="position: relative; display: block; height: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); width: 0px;"></div></div><div style="position: absolute; width: 6px; right: 2px; bottom: 2px; top: 2px; border-radius: 3px;"><div style="position: relative; display: block; width: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); height: 0px;"></div></div></div></div></div>
    <my-database
      v-if="dialogPic"
      type="7"
      :closeFunc="closePic"
      :submitFunc="addPic"
    ></my-database>
     <chooseScene :infos='resData' v-if='alert' :closeAlert='closeAlert1'></chooseScene>  
  </div>
</template>
<style>
.hyFrqY {
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow-wrap: normal;
    display: block;
    width: 135px;
    overflow: hidden;
}
.NbaJv {
    color: rgb(66, 122, 251);
    cursor: pointer;
}
.gCOZys {
    width: 34px;
    height: 34px;
    margin-right: 10px;
    cursor: pointer;
}
.Checkbox_checkbox_2hIu2H {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    background-color: #fff;
    border: 1px solid #d8d8d8;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.jDvrWE {
    font-size: 12px;
    color: rgb(170, 170, 170);
    margin-left: 5px;
    
}
.Checkbox_checked_3yFHX3 {
    background-color: #427afb;
    border-color: #427afb;
}
.Checkbox_checkbox_2hIu2H, .Checkbox_container_jYKPxJ {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.Checkbox_container_jYKPxJ {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
}
.fCtgHg {
    display: flex;
    align-content: center;
    -webkit-box-pack: justify;
    justify-content: space-between;
}
.select-list {
  width: 100%;
}
.select-list .el-input__inner {
  width: 100%;
  background-color: #3c3c3c;
  border-color: #525252;
  color: #f7f7f7;
}
.title-input {
  margin: 10px 0 0;
}
.title-input .el-input__inner {
  height: 34px;
  color: #fff;
  background-color: #2c2c2c;
}
</style>
<style scoped>
.PageLayout_sidebar_1JSEld {
    -ms-flex: 0 0 230px;
    flex: 0 0 230px;
    width: 230px;
}
.PageLayout_sidebar_1JSEld, .PageLayout_toolbar_2y1UEJ {
    position: relative;
    -webkit-box-flex: 0;
    border-color: #4b4b4b #000 #000 #4b4b4b;
    border-style: solid;
    border-width: 1px;
}
.zVQab {
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
}
.block-align-center {
    -webkit-align-items: center;
    -webkit-box-pack: center;
    -ms-flex-align: center;
    -webkit-box-align: center;
    align-items: center;
}
.block-justify-between {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}
.block-horizontal-layout, .block-vertical-layout {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-direction: normal;
}
.pano-button-sm {
    height: 30px;
}
.pano-button-primary {
    background-color: #286efa;
    color: #fff;
}
.pano-button {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 30px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 3px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
}
.HelpIcon_root_WFV-sl {
    width: 18px;
    height: 18px;
}
.ApplyTo_btn_1viHCu {
    padding: 0;
    width: 60px;
    font-size: 12px;
}
.pano-button-xs {
    height: 24px;
}
.pano-button-outline {
    background-color: rgba(0,0,0,0);
    color: #286efa;
    border: 1px solid #286efa;
}
.ApplyTo_root_EGt0qa {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.ContentBox_box_18qEQ3 {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #2c2c2c;
    color: #aaa;
    border: 1px solid #4b4b4b;
    border-radius: 3px;
}
.rightcontent {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: auto;
  flex: auto;
}
.midContent {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  background-color: #333;
  color: #fff;
  box-sizing: border-box;
}
.content {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
}
.content h2 {
  height: 100%;
  text-align: center;
  vertical-align: middle;
  line-height: 100%;
}
.content #webglPano {
  position: absolute;
  top: 20px;
  left: 20px;
  bottom: 20px;
  right: 20px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.7);
  overflow: hidden;
  border-radius: 2px 2px;
}
.rightBar {
  -ms-flex: 0 0 230px;
  flex: 0 0 230px;
  width: 230px;
  position: relative;
  -webkit-box-flex: 0;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  background-color: #333;
  color: #fff;
}
.right-main {
  display: flex;
  flex-flow: column nowrap;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.hotspotList_header {
  padding: 0 15px;
  height: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.openAdd {
  height: 30px;
  width: 155px;
  line-height: 0;
}

.points {
  width: 70px;
  height: 70px;
  position: absolute;
  z-index: 1;
}
.points.active {
  background-color: rgba(0, 0, 0, 0.2);
  border: 2px solid #ffbd10;
  outline-offset: -2px;
  border-radius: 8px;
}
.hotspotList_list {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.list-main {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.list-scroll {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow: scroll;
  margin-right: -17px;
  margin-bottom: -17px;
}

.list-title {
  padding: 15px;
}

.li {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 40px;
  margin-bottom: 5px;
  line-height: 20px;
  padding: 0 15px;
  cursor: pointer;
  background-color: #3a3a3a;
}

.li:hover {
  background-color: #6b6b6b;
}

.li-img {
  width: 22px;
  height: 22px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.li-title {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-left: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-height: 1em;
}

.li-type {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 60px;
  flex: 0 0 60px;
  color: #aaa;
  font-size: 12px;
  text-align: right;
}

.right-model {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  width: 260px;
  -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  background-color: #333;
  color: #fff;
  -webkit-animation-name: move;
  animation-name: move;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
}

@keyframes move {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

.model-header {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  border-bottom: 1px solid #000;
}

.model-title {
  display: flex;
  align-items: center;
  flex: 1 auto;
  padding-left: 15px;
  font-size: 16px;
}

.model-close {
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 35px;
  height: 35px;
  cursor: pointer;
}

.el-icon-close {
  font-size: 16px;
}

.model-body {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
  border-bottom: 1px solid #000;
  border-top: 1px solid #4b4b4b;
}
.body-main {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow: auto;
  margin-right: -17px;
  margin-bottom: -17px;
}

.hotspot-header {
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 15px;
  height: 40px;
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(4%, hsla(0, 0%, 100%, 0.3)),
    color-stop(98%, hsla(0, 0%, 100%, 0))
  );
  background-image: -o-linear-gradient(
    left,
    hsla(0, 0%, 100%, 0.3) 4%,
    hsla(0, 0%, 100%, 0) 98%
  );
  background-image: linear-gradient(
    90deg,
    hsla(0, 0%, 100%, 0.3) 4%,
    hsla(0, 0%, 100%, 0) 98%
  );
}

.hotspot-body {
  padding: 20px 30px 30px 15px;
  text-align: left;
}
.hotspot-list-block {
  height: 170px;
  position: relative;
  overflow: hidden;
}
.hotspot-list {
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.hotspot-li {
  width: 35px;
  height: 35px;
  margin: 0 2px 15px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}
.hotspot-li.active {
  outline: 2px solid #ffbd10;
  outline-offset: -2px;
}

.title-row {
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 10px;
}

.show-title {
  display: flex;
  align-content: center;
  align-items: center;
}

.title-checkbox {
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #d8d8d8;
  cursor: pointer;
  color: white !important;
  margin-right: 5px;
}

.title-checkbox.active {
  background-color: #427afb;
  border-color: #427afb;
}

.title-font {
  margin: 20px 0;
  text-align: left;
}

.font-size {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.optionItem {
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #aaa;
  cursor: pointer;
}

.optionItem img {
  flex: auto;
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.scene-list {
  text-align: left;
  margin-top: 20px;
}

.choose-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 10px;
}

.choose-li {
  width: 65px;
  position: relative;
  margin-bottom: 10px;
  text-align: center;
  cursor: pointer;
}
.choose-li.active img {
  outline: 2px solid #ffbd10;
  outline-offset: -2px;
}

.choose-list img {
  height: 65px;
  width: 100%;
}

.choose-li .name {
  height: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-height: 1em;
  line-height: 18px;
}

.model-foot {
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 15px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 65px;
  flex: 0 0 65px;
  border-top: 1px solid #4b4b4b;
  z-index: 10000;
  background-color: #333;
}

.pointAdd,
.pointDelete {
  height: 34px;
  width: 110px;
  line-height: 0;
}

.btn-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px 0 20px;
}
.delpic {
  height: 20px;
  width: 20px;
  display: none;
  position: absolute;
  top: 2px;
  right: 2px;
  background-color: rgba(0, 0, 0, 0.7);
}
.choose-list:hover .delpic {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<script>
import BottomBar from '../components/webgl/BottomBar.vue'
import MyDatabase from '../components/database3.vue'
import chooseScene from '../components/chooseScene.vue'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader_z'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'
import https from '../https.js'
let vm = null
const vertexShader = [
  'varying vec3 pPos;',
  'void main()',
  '{',
  '    pPos = position;',
  '    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );',
  '    gl_Position = projectionMatrix * mvPosition;',
  '}'
].join('\n')

const fragmentShader = [
  '#ifdef GL_ES',
  '    precision highp float;',
  '#endif',
  'const float PI = 3.1415926;',
  'const float TWO_PI = 6.2831852;',

  'uniform samplerCube texture;',
  'uniform vec3 cPosition;',
  'varying vec3 pPos;',
  'void main()',
  '{',
  '    vec3 np = normalize(pPos-cPosition);',
  '    gl_FragColor = textureCube( texture, vec3(np.x,np.y,-np.z ));',
  '}'
].join('\n')
export default {
  name: '',
  components: {
    BottomBar,
    MyDatabase,
    chooseScene
  },
  computed: {
    nowPointActiveIndex: function() {
      return this.panoEditInfos.nowPointActiveIndex
    },
    nowPanoActiveIndex: function() {
      return this.panoEditInfos.nowPanoActiveIndex
    },
    getPanoInfos: function() {
      var arr = []
      return this.infos.panos ? this.infos.panos : arr
    },
    getPointInfos: function() {
      var arr = []
      if (this.infos.panos) {
        for (var i = 0; i < this.infos.panos.length; i++) {
          if (this.infos.panos[i].posX != null) {
            arr.push(this.infos.panos[i])
          }
        }
      }
      return arr
    }
  },
  props: [
    'infos',
    'panoEditInfos',
    "nowFloor", 
    "resData"
  ],
  data() {
    return {
      lon: 270,
      lat: 0,
      phi: 0,
      theta: 0,
      x: 0,
      y: 0,
      z: 0,
      nowType: '',
      useModel: false,
      pointTipShow: false,
      addPanoBtnCanUse: false,
      panoPointActiveIndex: -1,
      pointInfos: [],
      addPointId: '',
      isTopView: true,
      hasInit: false,
      isauto:false,
      isloop:false,
      alert:false,
      musicUpload:false,
      audioUpload:false,
      hotPointlist: [
        // {
        //   id: "60868e8e-dd95-445f-847a-d76630e48452",
        //   hotType: 1,
        //   posX: 349.9472748515578,
        //   posY: -49.4043211555136,
        //   posZ: -4963.106072578425,
        //   physicalFile_Scene_ID: "0af44a12-c133-47df-bbb8-0ed213f55e46",
        //   hotTitle: "ghdjdghj  ",
        //   hotContext: "string",
        //   hotPointURL: "1",
        //   status: 1,
        //   createTime: "2020-06-16T14:36:11.14",
        // }
      ],
      modelShow: false, //右侧添加热点侧边栏
      options: [
        {
          label: '全景切换',
          value: 1
        },
        {
          label: '超链接',
          value: 2
        },
        {
          label: '图片',
          value: 3
        },
        {
          label: '视频',
          value: 4
        }
      ],
      musicSrc:'',
      audioSrc:'',
      musicTtile:'',
      musicId:'',
      audioTitle:'',
      audioId:'',
      titleCheck: false, //标题是否显示
      fontSize: '1', //标题字号
      dialogPic: false, //添加图片对话框
      point: {
        num: -1, //第几个
        id: '',
        url: '', // 热点图标
        title: '', //标题名字
        type: 1, // 热点类型
        x: 10,
        y: 10,
        w: 33, //宽的一半
        h: 33, //高的一半
        posx: 0,
        posy: 0,
        posz: -2000,
        show: false,
        chooseID: '', //跳转全景的id
        webUrl: '', //超链接网址
        picArr: [], //关联图片ids
        videoArr: [] //关联视频ids
      },
      pointNew: {
        num: -1,
        id: '00000000-0000-0000-0000-000000000000',
        url: '1', // 热点图标
        title: '', //标题名字
        type: 1, // 热点类型
        x: 10,
        y: 10,
        w: 33, //宽的一半
        h: 33, //高的一半
        posx: 0,
        posy: 0,
        posz: -2000,
        show: true,
        chooseID: '', //跳转全景的id
        webUrl: '', //超链接网址
        picArr: [], //关联图片ids
        videoArr: [] //关联视频ids
      },
      musicIconSrc:'./images/play1.png',
      audioIconSrc:'./images/play1.png',
      src3:'./images/play1.png',
      src4:'./images/pause1.png',
      chooseType:1,
      num:0,
      musicIsPlay:false,
      audioIsPlay:false,
    }
  },
  created() {
    document.oncontextmenu = function() {
      return false
    }
    vm = this
  },
  watch: {
    getPanoInfos(val) {
      this.createAllHotPoint()
      if (!this.hasInit) {
        this.hasInit = true
        this.generatePano(
          this.panoGroup,
          this.infos.panos[this.nowPanoActiveIndex]
        )
        
      }
    }
  },
  mounted() {
    this.containerUp = null
    this.sceneUp = null
    this.cameraUp = null
    this.meshUp = null
    this.rendererUp = null
    this.containerWUp = 0
    this.containerHUP = 0
    this.targetBoxUp = null
    this.rafId = null
    this.container = null
    this.scene = null
    this.camera = null
    this.mesh = null
    this.renderer = null
    this.controls = null
    this.containerW = 0
    this.containerH = 0
    this.selectionBox = null
    this.transformControls = null
    this.mouse = new THREE.Vector2()
    this.raycaster = new THREE.Raycaster()
    this.onDownPosition = new THREE.Vector2()
    this.onUpPosition = new THREE.Vector2()
    this.pmremGenerator = null
    this.isDown = false
    this.isMoving = false
    this.isModelShow = false
    this.panoGroup = new THREE.Group()
    this.pointGroup = new THREE.Group()
    this.fingers = null
    this.onPointerDownPointerX = 0
    this.onPointerDownPointerY = 0
    this.onPointerDownLon = 0
    this.onPointerDownLat = 0
    this.onPointerDownPointerX0 = 0
    this.onPointerDownPointerY0 = 0
    this.onPointerDownPointerX1 = 0
    this.onPointerDownPointerY1 = 0
    this.preMoveX = 0
    this.preMoveY = 0
    this.offX = 0
    this.offY = 0
    this.disFinger = 0
    this.canDamp = false
    this.dampingFactor = 0.2
    this.targetBox = null
    this.hasLoaded = false
    this.planeUniforms = null
    this.preV = new THREE.Vector2()
    this.textrueLoader = new THREE.TextureLoader()
    this.clock = new THREE.Clock()
    this.init()
    this.animate()
    console.log(this.infos)
  },
  methods: {
    renewInfos(arr){
      console.log(this.audioSrc)
      var musicInfo = {
        src: this.musicSrc,
        autoplay: this.isauto,
        replay:this.isloop
      }
      console.log(musicInfo)
      switch (this.nowType){
        case 'audio':
          if(this.audioSrc!=''){
            for(var i = 0 ; i < this.resData.length;i++){
              for(var j = 0 ; j < this.resData[i].panos.length;j++){
                var id = this.resData[i].panos[j].physicalFile.id;
                if(arr.findIndex(item=>item==id)!=-1){
                  this.resData[i].panos[j].audioSrc = this.audioSrc
                }
              }
            }
          }else{
            this.$notify({
                title: "警告",
                message: "如果不选择音乐,会执行讲解删除操作",
                duration: 1000,
                type: "warning",
              });
            for(var i = 0 ; i < this.resData.length;i++){
              for(var j = 0 ; j < this.resData[i].panos.length;j++){
                var id = this.resData[i].panos[j].physicalFile.id;
                if(arr.findIndex(item=>item==id)!=-1){
                  this.resData[i].panos[j].audioSrc = ''
                }
              }
            }
          }
          break;
        case 'music':
          if(musicInfo.src!=''){
            for(var i = 0 ; i < this.resData.length;i++){
              for(var j = 0 ; j < this.resData[i].panos.length;j++){
                var id = this.resData[i].panos[j].physicalFile.id;
                if(arr.findIndex(item=>item===id)!=-1){
                  this.resData[i].panos[j].musicInfo = musicInfo
                }
              }
            }
          }else{
            this.$notify({
                title: "警告",
                message: "如果不选择音乐,会执行背景音乐删除操作",
                duration: 1000,
                type: "warning",
              });
            for(var i = 0 ; i < this.resData.length;i++){
              for(var j = 0 ; j < this.resData[i].panos.length;j++){
                var id = this.resData[i].panos[j].physicalFile.id;
                if(arr.findIndex(item=>item===id)!=-1){
                  this.resData[i].panos[j].musicInfo = null
                }
              }
            }
          }
          break;
        default:
          break;
      }
      console.log(this.resData)
    },
    playOrPause(str){
      switch(str){
        case 'music':
          if(this.musicIsPlay){
            this.$refs.music.currentTime = 0
            this.$refs.music.pause()
            this.musicIconSrc = this.src3
          }else{
            this.audioIsPlay = false
            if(this.$refs.audio){
              this.$refs.audio.currentTime = 0
              this.$refs.audio.pause()
              this.audioIconSrc = this.src3
            }
            this.$refs.music.currentTime = 0
            this.$refs.music.play()
            this.musicIconSrc = this.src4
          }
          this.musicIsPlay = !this.musicIsPlay
          break;
        case 'audio':
          if(this.audioIsPlay){
            this.$refs.audio.currentTime = 0
            this.$refs.audio.pause()
            this.audioIconSrc = this.src3
          }else{
            this.musicIsPlay = false
            if(this.$refs.music){
              this.$refs.music.currentTime = 0
              this.$refs.music.pause()
              this.musicIconSrc = this.src3
            }
            this.$refs.audio.currentTime = 0
            this.$refs.audio.play()
            this.audioIconSrc = this.src4
          }
          this.audioIsPlay = !this.audioIsPlay
          break;
        default:
          break;
      }
    },
    chooseAudio(){
      this.dialogPic = true
      this.chooseType=1
    },
    chooseAudio1(){
      this.dialogPic = true
      this.chooseType=2
    },
    selectScene(){
      this.alert = true
      this.nowType='music'
    },
    selectScene1(){
      this.alert = true
      this.nowType='audio'
    },
    closeAlert1(){
      this.alert = false
    },
    changeLoop(){
      this.isloop = !this.isloop
    },
    changeAuto(){
      this.isauto = !this.isauto
    },
    changeView() {
      if (this.nowPointActiveIndex !== -1) {
        if (this.isTopView) {
          this.isTopView = false
          var pos = this.getPointInfos[this.nowPointActiveIndex].position
          this.cameraUp.position.set(pos.x, pos.y, pos.z)
          this.posObj(
            this.targetBoxUp,
            this.cameraUp,
            10000,
            this.lon,
            this.lat,
            0
          )
        } else {
          this.isTopView = true
          this.cameraUp.position.set(0, 45000, 0)
          this.targetBoxUp.position.set(0, 0, 0)
        }
      }
    },
    addPoint(id) {
      if (id !== '') {
        for (var i = 0; i < this.getPanoInfos.length; i++) {
          if (this.getPanoInfos[i].id === id) {
            this.getPanoInfos[i].position = { x: 0, y: 0, z: 0 }
            var pos = new THREE.Vector3(0, 0, 0)
            var vec = pos.project(this.cameraUp)
            this.getPanoInfos[i].screenPos = {}
            this.getPanoInfos[i].screenPos.x =
              Math.round(vec.x * 320 + 320) - 25
            this.getPanoInfos[i].screenPos.y =
              Math.round(-vec.y * 180 + 180) - 25
            this.$parent.changePanoEditInfos('nowPanoActiveIndex', i)
          }
        }
        this.pointTipShow = false
        this.$parent.changePanoEditInfos(
          'nowPointActiveIndex',
          this.getPointInfos.length - 1
        )
        this.changePanoMat(this.nowPanoActiveIndex)
      } else {
        this.$notify({
          title: '警告',
          message: '请选择需要添加点的全景图',
          duration: 1000,
          type: 'warning'
        })
      }
    },
    changePos() {
      var pos = new THREE.Vector3(
        this.getPointInfos[this.nowPointActiveIndex].position.x,
        this.getPointInfos[this.nowPointActiveIndex].position.y,
        this.getPointInfos[this.nowPointActiveIndex].position.z
      )
      var vec = pos.project(this.cameraUp)
      // this.getPointInfos[this.nowPointActiveIndex].screenPos.x = Math.round(vec.x * 320 + 320) - 25
      // this.getPointInfos[this.nowPointActiveIndex].screenPos.y = Math.round(-vec.y * 180 + 180) - 25

      this.infos.panos[this.nowPanoActiveIndex].screenPos = {}
      this.infos.panos[this.nowPanoActiveIndex].screenPos.x =
        Math.round(vec.x * 320 + 320) - 25
      this.infos.panos[this.nowPanoActiveIndex].screenPos.y =
        Math.round(-vec.y * 180 + 180) - 25

      if (!this.isTopView) {
        var posC = this.getPointInfos[this.nowPointActiveIndex].position
        this.cameraUp.position.set(posC.x, posC.y, posC.z)
        this.posObj(
          this.targetBoxUp,
          this.cameraUp,
          10000,
          this.lon,
          this.lat,
          0
        )
      }
    },
    movePoint(ev) {
      const _this = this
      var oEvent = ev || event
      oEvent.preventDefault()
      var prePosX = oEvent.clientX
      var prePosY = oEvent.clientY
      var startX = _this.point.x
      var startY = _this.point.y
      var nowLeft, nowTop, offsetX, offsetY
      var onMouseMove = function(ev) {
        var oEvent = ev || event
        offsetX = oEvent.clientX - prePosX
        offsetY = oEvent.clientY - prePosY
        nowLeft = offsetX + startX
        nowTop = offsetY + startY
        if (nowLeft >= 0 && nowLeft <= _this.containerW - 68) {
          _this.point.x = nowLeft
        }
        if (nowTop >= 0 && nowTop <= _this.containerH - 68) {
          _this.point.y = nowTop
        }
      }
      document.addEventListener('mousemove', onMouseMove, false)
      var onMouseUp = function() {
        document.removeEventListener('mousemove', onMouseMove, false)
        document.removeEventListener('mouseup', onMouseUp, false)

        var mouse = new THREE.Vector2()
        mouse.x = ((_this.point.x + _this.point.w) / _this.containerW) * 2 - 1
        mouse.y = -((_this.point.y + _this.point.h) / _this.containerH) * 2 + 1
        var raycaster = new THREE.Raycaster()
        raycaster.setFromCamera(mouse, _this.camera)
        var intersects = raycaster.intersectObjects(_this.panoGroup.children)
        if (intersects.length > 0) {
          var point = intersects[0].point.normalize().multiplyScalar(2000)
          _this.point.posx = point.x.toFixed(2)
          _this.point.posy = point.y.toFixed(2)
          _this.point.posz = point.z.toFixed(2)
        }
      }

      document.addEventListener('mouseup', onMouseUp, false)
    },
    getZoom(d1, d2) {
      var _this = this
      var oDiv1 = this.$refs[d1]
      var oDiv2 = this.$refs[d2]

      var containerW = oDiv2.clientWidth
      var containerH = oDiv2.clientHeight
      oDiv1.onmousedown = ev => {
        ev.preventDefault()
        var oEvent = ev || event
        var prePosX = oEvent.clientX
        var prePosY = oEvent.clientY
        var preLeft = oDiv1.offsetLeft
        var preTop = oDiv1.offsetTop

        document.onmousemove = function(ev) {
          var oEvent = ev || event
          var offsetX = oEvent.clientX - prePosX
          var offsetY = oEvent.clientY - prePosY
          var nowLeft = preLeft + offsetX
          var nowTop = preTop + offsetY
          // if(nowLeft >= -25 && nowLeft <= containerW - 25) {
          //   vm.getPointInfos[num].screenPos.x = nowLeft
          // }
          // if(nowTop >= -25 && nowTop <= containerH - 25) {
          //   vm.getPointInfos[num].screenPos.y = nowTop
          // }
        }
        document.onmouseup = function() {
          document.onmousemove = null
          document.onmouseup = null
        }
      }
    },
    init() {
      this.container = this.$refs.webgl
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.scene = new THREE.Scene()
      this.targetBox = new THREE.Mesh(
        new THREE.BoxBufferGeometry(1, 1, 1),
        new THREE.MeshBasicMaterial({
          color: 0xff0000,
          transparent: true,
          opacity: 0
        })
      )
      this.scene.add(this.targetBox)
      this.scene.add(this.panoGroup)
      this.scene.add(this.pointGroup)
      this.camera = new THREE.PerspectiveCamera(
        60,
        this.containerW / this.containerH,
        10,
        99999
      )

      this.camera.position.set(0, 0, 0)
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      this.camera.lookAt(this.targetBox.position)
      this.scene.add(this.camera)

      const ambientLight = new THREE.AmbientLight(0xffffff)
      this.scene.add(ambientLight)
      this.planeUniforms = {
        cPosition: { value: new THREE.Vector3() },
        texture: { value: null },
        ...THREE.UniformsLib.lights
      }
      const planeMat = new THREE.ShaderMaterial({
        uniforms: this.planeUniforms,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        lights: true
      })
      planeMat.needsUpdate = true

      if (this.infos.panos) {
        this.generatePano(
          this.panoGroup,
          this.infos.panos[this.nowPanoActiveIndex]
        )
        this.createAllHotPoint()
      }

      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      })
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.setSize(this.containerW, this.containerH)
      this.container.appendChild(this.renderer.domElement)
      window.addEventListener('resize', this.onresize, false)

      this.renderer.domElement.addEventListener(
        'mousedown',
        this.onRendererMouseDown,
        false
      )
      this.renderer.domElement.addEventListener(
        'mousemove',
        this.onRendererMouseMove,
        false
      )
      this.renderer.domElement.addEventListener(
        'mouseup',
        this.onRendererMouseUp,
        false
      )
    },
    onRendererMouseDown(event) {
      event.preventDefault()
      this.isMoving = false
      this.isDown = true
      this.canDamp = false
      this.preV.x = event.clientX
      this.preV.y = event.clientY
      this.preMoveX = this.onPointerDownPointerX = event.clientX
      this.preMoveY = this.onPointerDownPointerY = event.clientY
      this.onPointerDownLon = this.lon
      this.onPointerDownLat = this.lat
    },
    onRendererMouseMove(event) {
      event.preventDefault()
      this.isMoving = true
      if (this.isDown) {
        this.lon =
          (this.onPointerDownPointerX - event.clientX) * 0.15 +
          this.onPointerDownLon
        this.lat =
          (event.clientY - this.onPointerDownPointerY) * 0.15 +
          this.onPointerDownLat
        this.posObj(this.targetBox, this.camera, 1, this.lon, this.lat, 0)
        if (!this.isTopView && this.nowPointActiveIndex !== -1) {
          this.posObj(
            this.targetBoxUp,
            this.cameraUp,
            1,
            this.lon,
            this.lat,
            0
          )
        }
        this.offX = event.clientX - this.preMoveX
        this.offY = event.clientY - this.preMoveY
        this.preMoveX = event.clientX
        this.preMoveY = event.clientY
      }
    },
    onRendererMouseUp(event) {
      const _this = this
      var mouse = new THREE.Vector2()
      mouse.x = ((_this.point.x + _this.point.w) / _this.containerW) * 2 - 1
      mouse.y = -((_this.point.y + _this.point.h) / _this.containerH) * 2 + 1
      var raycaster = new THREE.Raycaster()
      raycaster.setFromCamera(mouse, _this.camera)
      var intersects = raycaster.intersectObjects(_this.panoGroup.children)
      if (intersects.length > 0) {
        var point = intersects[0].point.normalize().multiplyScalar(2000)
        _this.point.posx = point.x.toFixed(2)
        _this.point.posy = point.y.toFixed(2)
        _this.point.posz = point.z.toFixed(2)
      }
      // console.log(
      //   "点坐标" + _this.point.posx,
      //   _this.point.posy,
      //   _this.point.posz
      // );

      this.isMoving = false
      this.isDown = false
    },
    changePanoMatFromPoint(num) {
      // this.nowPointActiveIndex = num
      this.$parent.changePanoEditInfos('nowPointActiveIndex', num)
      var id = this.getPointInfos[num].id
      var panoNum = this.getPanoInfos.findIndex(item => item.id === id)
      this.$parent.changePanoEditInfos('nowPanoActiveIndex', panoNum)
      // this.nowPanoActiveIndex = panoNum
      this.lon = 270
      this.lat = 0
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      var r = this.infos.panos[this.nowPanoActiveIndex].physicalFile.filePath
      var urls = [
        r + '/l1_r_1_1.jpg',
        r + '/l1_l_1_1.jpg',
        r + '/l1_u_1_1.jpg',
        r + '/l1_d_1_1.jpg',
        r + '/l1_f_1_1.jpg',
        r + '/l1_b_1_1.jpg'
      ]

      var textureCube = new THREE.CubeTextureLoader().load(urls)
      textureCube.format = THREE.RGBFormat
      textureCube.mapping = THREE.CubeRefractionMapping
      this.panoGroup.children[0].material.uniforms.texture.value = textureCube
    },
    changePanoMat(num) {
      this.num = num
      console.log(num)
      // this.nowPanoActiveIndex = num
      this.$parent.changePanoEditInfos('nowPanoActiveIndex', num)
      var id = this.getPanoInfos[num].id
      var pointNum = this.getPointInfos.findIndex(item => item.id === id)
      // this.nowPointActiveIndex = pointNum
      this.$parent.changePanoEditInfos('nowPointActiveIndex', pointNum)
      this.lon = 270
      this.lat = 0
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      var r = this.infos.panos[this.nowPanoActiveIndex].physicalFile.filePath
      var urls = [
        r + '/l1_r_1_1.jpg',
        r + '/l1_l_1_1.jpg',
        r + '/l1_u_1_1.jpg',
        r + '/l1_d_1_1.jpg',
        r + '/l1_f_1_1.jpg',
        r + '/l1_b_1_1.jpg'
      ]
      var textureCube = new THREE.CubeTextureLoader().load(urls)
      textureCube.format = THREE.RGBFormat
      textureCube.mapping = THREE.CubeRefractionMapping
      this.panoGroup.children[0].material.uniforms.texture.value = textureCube
    },
    posObj(obj, cam, r, lon, lat, h) {
      lat = Math.max(-85, Math.min(85, lat))
      var phi = THREE.Math.degToRad(90 - lat)
      var theta = THREE.Math.degToRad(lon)
      obj.position.x = r * Math.sin(phi) * Math.cos(theta) + cam.position.x
      obj.position.y = r * Math.cos(phi) + cam.position.y
      obj.position.z = r * Math.sin(phi) * Math.sin(theta) + cam.position.z
      // console.log("物体坐标" + obj.position.x, obj.position.y, obj.position.z);
    },
    generatePano(panoGroup, data) {
      var r = data.physicalFile.filePath
      var urls = [
        r + '/l1_r_1_1.jpg',
        r + '/l1_l_1_1.jpg',
        r + '/l1_u_1_1.jpg',
        r + '/l1_d_1_1.jpg',
        r + '/l1_f_1_1.jpg',
        r + '/l1_b_1_1.jpg'
      ]

      var textureCube = new THREE.CubeTextureLoader().load(urls)
      textureCube.format = THREE.RGBFormat
      textureCube.mapping = THREE.CubeRefractionMapping
      var planeUniforms = {
        cPosition: { value: new THREE.Vector3(0, 0, 0) },
        texture: { value: textureCube },
        ...THREE.UniformsLib.lights
      }
      var cubeMat = new THREE.ShaderMaterial({
        uniforms: planeUniforms,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        lights: true
      })
      cubeMat.needsUpdate = true

      // var geometry = new THREE.BoxBufferGeometry(5000, 5000, 5000)
      var geometry = new THREE.SphereBufferGeometry(5000, 32, 32)
      geometry.scale(1, 1, -1)
      var cubeMesh = new THREE.Mesh(geometry, cubeMat)
      cubeMesh.visible = true
      cubeMesh.name = data.physicalFile.fileName
      panoGroup.add(cubeMesh)
    },
    onresize() {
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.camera.aspect = this.containerW / this.containerH
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.containerW, this.containerH)
    },
    render() {
      this.renderer.render(this.scene, this.camera)
    },
    animate() {
      var delta = this.clock.getDelta()
      this.camera.lookAt(this.targetBox.position)
      this.rafId = requestAnimationFrame(this.animate)
      TWEEN.update()
      this.render()
    },

    open(num) {
      if (num == -1) {
        const posx = this.containerW / 2 - this.point.w
        const posy = this.containerH / 2 - this.point.h
        this.pointNew.x = posx
        this.pointNew.y = posy
        this.point = JSON.parse(JSON.stringify(this.pointNew))
      } else {
        const x = this.hotPointlist[num].hotPoint.posX
        const y = this.hotPointlist[num].hotPoint.posY
        const z = this.hotPointlist[num].hotPoint.posZ

        this.point.num = num
        this.point.id = this.hotPointlist[num].hotPoint.id
        this.point.posx = this.hotPointlist[num].hotPoint.posX
        this.point.posy = this.hotPointlist[num].hotPoint.posY
        this.point.posz = this.hotPointlist[num].hotPoint.posZ
        this.point.url = this.hotPointlist[num].hotPoint.hotPointURL
        this.point.type = this.hotPointlist[num].hotPoint.hotType
        this.point.title = this.hotPointlist[num].hotPoint.hotTitle
        
        this.pointGroup.children[num].visible = false
        switch (this.point.type) {
          case 1:
            this.point.chooseID = this.hotPointlist[num].hotPoint.hotContext
           
            break
          case 2:
            this.point.webUrl = this.hotPointlist[num].hotPoint.hotContext
            break
          case 3:
            this.point.picArr = JSON.parse(JSON.stringify(this.hotPointlist[num].physicalFilelist))
            break
          case 4:
            this.point.videoArr = JSON.parse(JSON.stringify(this.hotPointlist[num].physicalFilelist))
            break
        }
        this.editHotPoint(num)

        // this.point.x = this.getXY(x, y, z).x
        // this.point.y = this.getXY(x, y, z).y
      }

      this.modelShow = true
    },
    seekAngle(x, y, z) {
      var r = Math.sqrt(x * x + y * y + z * z)
      var phi = Math.acos(y / r)
      var theta = Math.atan(z / x)
      var lon
      if(x >= 0) {
        lon = theta * 180 / Math.PI
      }else {
        lon = 180 + theta * 180 / Math.PI
      }

      var lat = 90 - phi * 180 / Math.PI
      return [lon, lat]
    },
    close() {
      this.modelShow = false
      if (this.point.num != -1) {
        this.pointGroup.children[this.point.num].visible = true
      }
      this.point.show = false
    },
    createAllHotPoint() {
      this.pointGroup.children=[];
      const hotList = this.infos.panos[this.nowPanoActiveIndex].hotPointlist
      this.hotPointlist = hotList
      for (let i = 0; i < hotList.length; i++) {
        this.createHotPoint(hotList[i].hotPoint)
      }
    },
    createHotPoint(arr) {
      var spriteMap = new THREE.TextureLoader().load(
        'imgs/points/' + arr.hotPointURL + '.png'
      )
      var spriteMaterial = new THREE.SpriteMaterial({
        map: spriteMap,
        color: 0xffffff
      })
      var sprite = new THREE.Sprite(spriteMaterial)
      sprite.scale.set(200, 200, 1)
      //sprite.name = i;
      sprite.hotType = arr.hotType
      sprite.position.set(arr.posX, arr.posY, arr.posZ)
      this.pointGroup.add(sprite)
    },
    pointAdd() {
      const pointType = this.point.type
      switch (pointType) {
        case 1: //全景切换
          if (this.point.chooseID == '') {
            this.$notify({
              title: '警告',
              message: '请选择跳转的目标场景',
              duration: 2000,
              type: 'warning'
            })
          } else {
            const data = {
              hotPoint: {
                id: this.point.id,
                hotType: this.point.type,
                posX: this.point.posx,
                posY: this.point.posy,
                posZ: this.point.posz,
                physicalFile_Scene_ID: this.infos.panos[this.nowPanoActiveIndex].id,
                hotTitle: this.point.title,
                hotContext: this.point.chooseID,
                hotPointURL: this.point.url
              },
              physicalFilelist: []
            }
            //新增一个点
            if (this.point.num == -1) {
              this.$set(
                this.infos.panos[this.nowPanoActiveIndex].hotPointlist,
                this.infos.panos[this.nowPanoActiveIndex].hotPointlist.length,
                data
              )
              this.createHotPoint(data.hotPoint)
            } else {
              this.getPanoInfos[this.nowPanoActiveIndex].hotPointlist[
                this.point.num
              ] = data
              this.pointGroup.children[this.point.num].position.set(
                this.point.posx,
                this.point.posy,
                this.point.posz
              )
              this.pointGroup.children[this.point.num].visible = true
            }
            this.modelShow = false
            this.point.show = false
          }
          break
        case 2: //超链接
          if (this.point.webUrl == '') {
            this.$notify({
              title: '警告',
              message: '请填写要跳转的链接',
              duration: 2000,
              type: 'warning'
            })
          } else {
            const data = {
              hotPoint: {
                id: this.point.id,
                hotType: this.point.type,
                posX: this.point.posx,
                posY: this.point.posy,
                posZ: this.point.posz,
                physicalFile_Scene_ID: this.infos.panos[this.nowPanoActiveIndex].id,
                hotTitle: this.point.title,
                hotContext: this.point.webUrl,
                hotPointURL: this.point.url
              },
              physicalFilelist: []
            }
            //新增一个点
            if (this.point.num == -1) {
              this.$set(
                this.infos.panos[this.nowPanoActiveIndex].hotPointlist,
                this.infos.panos[this.nowPanoActiveIndex].hotPointlist.length,
                data
              )
              this.createHotPoint(data.hotPoint)
            } else {
              this.getPanoInfos[this.nowPanoActiveIndex].hotPointlist[
                this.point.num
              ] = data
              this.pointGroup.children[this.point.num].position.set(
                this.point.posx,
                this.point.posy,
                this.point.posz
              )
              this.pointGroup.children[this.point.num].visible = true
            }
            this.modelShow = false
            this.point.show = false
          }
          break
        case 3: //图片
          if (this.point.picArr.length == 0) {
            this.$notify({
              title: '警告',
              message: '请选择相册',
              duration: 2000,
              type: 'warning'
            })
          } else {
            const data = {
              hotPoint: {
                id: this.point.id,
                hotType: this.point.type,
                posX: this.point.posx,
                posY: this.point.posy,
                posZ: this.point.posz,
                physicalFile_Scene_ID: this.infos.panos[this.nowPanoActiveIndex].id,
                hotTitle: this.point.title,
                hotContext: this.point.webUrl,
                hotPointURL: this.point.url
              },
              physicalFilelist: this.point.picArr
            }
            //新增一个点
            if (this.point.num == -1) {
              this.$set(
                this.infos.panos[this.nowPanoActiveIndex].hotPointlist,
                this.infos.panos[this.nowPanoActiveIndex].hotPointlist.length,
                data
              )
              this.createHotPoint(data.hotPoint)
            } else {
              this.getPanoInfos[this.nowPanoActiveIndex].hotPointlist[
                this.point.num
              ] = data
              this.pointGroup.children[this.point.num].position.set(
                this.point.posx,
                this.point.posy,
                this.point.posz
              )
              this.pointGroup.children[this.point.num].visible = true
            }
            this.modelShow = false
            this.point.show = false
          }
          break
        case 4: //视频
          if (this.point.videoArr.length == 0) {
            this.$notify({
              title: '警告',
              message: '请选择视频',
              duration: 2000,
              type: 'warning'
            })
          } else {
            const data = {
              hotPoint: {
                id: this.point.id,
                hotType: this.point.type,
                posX: this.point.posx,
                posY: this.point.posy,
                posZ: this.point.posz,
                physicalFile_Scene_ID: this.infos.panos[this.nowPanoActiveIndex].id,
                hotTitle: this.point.title,
                hotContext: this.point.webUrl,
                hotPointURL: this.point.url
              },
              physicalFilelist: this.point.videoArr
            }
            //新增一个点
            if (this.point.num == -1) {
              this.$set(
                this.infos.panos[this.nowPanoActiveIndex].hotPointlist,
                this.infos.panos[this.nowPanoActiveIndex].hotPointlist.length,
                data
              )
              this.createHotPoint(data.hotPoint)
            } else {
              this.getPanoInfos[this.nowPanoActiveIndex].hotPointlist[
                this.point.num
              ] = data
              this.pointGroup.children[this.point.num].position.set(
                this.point.posx,
                this.point.posy,
                this.point.posz
              )
              this.pointGroup.children[this.point.num].visible = true
            }
            this.modelShow = false
            this.point.show = false
          }
          break
        default:
          break
      }
    },
    pointDelete() {
      this.infos.panos[this.nowPanoActiveIndex].hotPointlist.splice(
        this.point.num,
        1
      )
      this.pointGroup.remove(this.pointGroup.children[this.point.num])
      this.modelShow = false
      this.point.show = false
    },
    editHotPoint(num) {
      new TWEEN.Tween(this.targetBox.position)
        .to({ x: this.hotPointlist[num].hotPoint.posX, y: this.hotPointlist[num].hotPoint.posY, z: this.hotPointlist[num].hotPoint.posZ }, 1000)
        .easing(TWEEN.Easing.Exponential.InOut)
        .start().onUpdate(() => {
        }).onComplete(() => {
          var arr = this.seekAngle(this.targetBox.position.x, this.targetBox.position.y, this.targetBox.position.z)
          this.lon = arr[0]
          this.lat = arr[1]
          var json = this.getXY(this.targetBox.position.x, this.targetBox.position.y, this.targetBox.position.z)
          this.point.x = json.x
          this.point.y = json.y
          this.point.show = true
        })
    },
    getXY(posx, posy, poz) {
      const pos = new THREE.Vector3(posx, posy, poz)
      const vector = pos.project(this.camera)
      const halfWidth = this.containerW / 2
      const halfHeight = this.containerH / 2
      return {
        x: Math.round(vector.x * halfWidth + halfWidth) - 33,
        y: Math.round(-vector.y * halfHeight + halfHeight) - 33
      }
    },
    closePic() {
      this.dialogPic = false
    },
    addPic(data) {
        console.log(data)
        if(this.chooseType==1){
        this.musicUpload = true
        this.musicSrc = data[0].filePath
        this.musicTtile = data[0].fileName
        this.musicId = data[0].id
        this.infos.panos[this.num].musicID = data[0].id
        }
        else{
            this.audioUpload = true
            this.audioSrc = data[0].filePath
            this.audioTtile = data[0].fileName
            this.audioId = data[0].id
            this.infos.panos[this.num].audioID = data[0].id
        }
      
    },
    deleteMusic(){
      if(this.musicId!=''){
        this.musicUpload=false
        this.musicSrc = ''
        this.musicTtile = ''
        this.musicId = ''
        // this.infos.panos[this.num].musicID = ''
        this.musicIconSrc = this.src3
        this.musicIsPlay = false
      }
    },
     deleteAudio(){
      if(this.audioId!=''){
        this.audioUpload=false
        this.audioSrc = ''
        this.audioTtile = ''
        this.audioId = ''
        // this.infos.panos[this.num].audioID = ''
        this.audioIconSrc = this.src3
        this.audioIsPlay = false
      }
    },
    delPic(i) {
      if (this.point.type == '3') {
        this.point.picArr.splice(i, 1)
      } else {
        this.point.videoArr.splice(i, 1)
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onresize, false)
    cancelAnimationFrame(this.rafId)
    this.renderer.dispose()
    this.renderer.forceContextLoss()
    this.renderer.domElement = null
    this.renderer = null
    this.scene = null
    this.camera = null
    this.rafId = null
    this.container = null
    this.mesh = null
    this.controls = null
    this.modelInfo = null
  }
}
</script>
